export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://kzcomp.com').replace(/\/$/, '');

export const SITE = {
  name: 'KZCOMP',
  brand: 'KZCOMP — Competitive KZ',
  shortDescription:
    'KZCOMP is the home of competitive KZ — tournaments, leaderboards, daily map guessing and live streams for the CS2 and CS:GO climbing community.',
  longDescription:
    'KZCOMP is the central hub for competitive Kreedz Climbing (KZ). Follow CS2KZ, GOKZ, KZTimer, VNL, SimpleKZ and CKZ tournaments, climb global leaderboards, play the daily KZ map-guessing challenge, and watch matches live.',
  twitter: '@kzcomp',
  themeColor: '#0b0b0c',
  defaultImage: '/og-default.jpg',
  locale: 'en_US',
  organization: {
    name: 'KZCOMP',
    legalName: 'KZCOMP',
    url: SITE_URL,
    logo: `${SITE_URL}/logo512.png`,
    sameAs: [],
  },
};

export const KEYWORDS = [
  'KZ',
  'kreedz',
  'kreedz climbing',
  'cs2',
  'cs2 kz',
  'cs2kz',
  'csgo',
  'csgo kz',
  'gokz',
  'kztimer',
  'kzt',
  'vnl',
  'vanilla kz',
  'skz',
  'simplekz',
  'ckz',
  'classic kz',
  'kz tournament',
  'kz competitive',
  'kz leaderboard',
  'kz maps',
  'kz climbing',
  'kz speedrun',
  'counter-strike kz',
  'kz comp',
  'kzcomp',
  'movement',
];

export const absoluteUrl = (path = '') => {
  if (!path) return SITE_URL;
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE_URL}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const stripHtml = (html = '') =>
  String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const truncate = (text = '', max = 160) => {
  const t = String(text).trim();
  if (t.length <= max) return t;
  const cut = t.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(' ');
  return `${(lastSpace > 60 ? cut.slice(0, lastSpace) : cut).trim()}…`;
};
